export interface RegisterData {
  name: string;
  description: string;
  phone: string;
  email: string;
  password: string;
  confirmPassword: string;
  logoName: string;
  district: string;
  street: string;
  buildingNo: string;
  coverage: string[];
  openFrom: string;
  openTo: string;
  commercialRegName: string;
  idDocName: string;
  extraDocName: string;
}

export const initialRegisterData: RegisterData = {
  name: '',
  description: '',
  phone: '',
  email: '',
  password: '',
  confirmPassword: '',
  logoName: '',
  district: '',
  street: '',
  buildingNo: '',
  coverage: [],
  openFrom: '09:00',
  openTo: '22:00',
  commercialRegName: '',
  idDocName: '',
  extraDocName: '',
};

export const registerSteps = [
  { id: 1, title: 'الأساسيات', icon: 'ri-store-2-line' },
  { id: 2, title: 'العنوان والتغطية', icon: 'ri-map-pin-2-line' },
  { id: 3, title: 'المستندات', icon: 'ri-file-text-line' },
  { id: 4, title: 'المراجعة', icon: 'ri-check-double-line' },
];